var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-info"},[_c('admin-title',{attrs:{"title":"全域订单明细"}}),_c('card',{staticClass:"order-list"},[_c('tp-table',{attrs:{"table-data":_vm.qyOrderList,"columns":_vm.columns,"is-page":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }